import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _COMPANY_PREFIX;
export var COMPANY_TYPE;
(function (COMPANY_TYPE) {
  COMPANY_TYPE["HSMSF"] = "HSMSF";
  COMPANY_TYPE["FEIXIANG"] = "FEIXIANG";
  COMPANY_TYPE["PGQJYWYH"] = "PGQJYWYH";
  COMPANY_TYPE["JIANGUAN"] = "JIANGUAN";
  COMPANY_TYPE["FLYING"] = "FLYING";
  COMPANY_TYPE["WX_MOBILE"] = "WX_MOBILE";
})(COMPANY_TYPE || (COMPANY_TYPE = {}));
export var COMPANY_TYPE_LIST = [{
  label: '监管平台',
  value: COMPANY_TYPE.JIANGUAN
}, {
  label: '平谷区教育委员会',
  value: COMPANY_TYPE.PGQJYWYH
}, {
  label: '海上名师坊',
  value: COMPANY_TYPE.HSMSF
}, {
  label: '信息收集平台',
  value: COMPANY_TYPE.FLYING
}, {
  label: '微信公众号',
  value: COMPANY_TYPE.WX_MOBILE
}, {
  label: '飞象',
  value: COMPANY_TYPE.FEIXIANG
}];
export var COMPANY_PREFIX = (_COMPANY_PREFIX = {}, _defineProperty(_COMPANY_PREFIX, COMPANY_TYPE.JIANGUAN, '/jianguan'), _defineProperty(_COMPANY_PREFIX, COMPANY_TYPE.HSMSF, '/hsmsf'), _defineProperty(_COMPANY_PREFIX, COMPANY_TYPE.PGQJYWYH, '/pgqjywyh'), _defineProperty(_COMPANY_PREFIX, COMPANY_TYPE.FEIXIANG, '/'), _defineProperty(_COMPANY_PREFIX, COMPANY_TYPE.FLYING, '/flying'), _defineProperty(_COMPANY_PREFIX, COMPANY_TYPE.WX_MOBILE, '/wx-mobile'), _COMPANY_PREFIX);